export const homeRoutes = [
  {
    path: "/dashboard",
    name: "dashboard",
    meta: { onlyAdmin: true },
    component: () => import(/* webpackChunkName: "report" */ "./DashboardView.vue"),
  },
];
